import React from 'react';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';
import { useSelector } from 'react-redux';
import { getLocalString, localNames } from 'utils/localisation.service';

const ClickUpload = ({
  fileAccepts = '.xls, .doc, PNG, JPG or GIF',
  fileLimit = 50,
}) => {

  const locales = useSelector(state => state.forms?.localeStrings);
  return (
    <div className="custom-drag__upload-area">
      <div className="flex-column align-items-center">
        <UploadIcon className="mb-1" />
        <div className="d-flex align-items-center click-upload">
          <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD)}</div>
        </div>
        <div className="d-flex file-specs">
          <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD2)}</div>
        </div>
      </div>
    </div>
  );
};

export default ClickUpload;
